export default "__VITE_ASSET__C6kv8SsB__"